import { render } from "./BuyGetFreeTiersTable.vue?vue&type=template&id=d86b836e&scoped=true"
import script from "./BuyGetFreeTiersTable.vue?vue&type=script&lang=js"
export * from "./BuyGetFreeTiersTable.vue?vue&type=script&lang=js"

import "./BuyGetFreeTiersTable.vue?vue&type=style&index=0&id=d86b836e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d86b836e"]])

export default __exports__